import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const CTA = () => {
  const { t } = useTranslation('cta');
  const navigate = useNavigate();
  const [referral, setReferral] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('refcode');
    if (ref) setReferral(ref);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      const formData = new FormData();
      formData.append('access_key', 'a4ca5cb4-b7d5-492b-9045-331eccc4038b');
      formData.append('name', name);
      formData.append('email', email);
      formData.append('referral_code', referral || 'direct');
      formData.append('source', 'safe-gpt.co');
      formData.append('subject', 'New Registration - Нейропрактикум');
      formData.append('page_url', window.location.href);
      formData.append('submitted_at', new Date().toISOString());

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (result.success) {
        console.log('Form submitted successfully:', { name, email, referral });

        setTimeout(() => {
          navigate('/thank-you');
        }, 500);
      } else {
        throw new Error(result.message || 'Form submission failed');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitError('Произошла ошибка при отправке формы. Попробуйте еще раз.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id='cta'>
      <div className='container tc'>
        <div className='s-64'></div>
        <h3 className='title-sub'>{t('cta.header.title')}</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          {t('cta.header.subtitle')}
        </h4>
        <div className='s-48'></div>
        <div className='card tl b-none p-5'>
          <div className='m-5'>
            <div className='row'>
              <div className='col-lg-6'>
                <h3 className='title-sub w-100' style={{ lineHeight: 1.2 }}>
                  {t('cta.form.title')}
                </h3>
                <div className='s-32'></div>
                <form className='referral-form' style={{ maxWidth: 420, textAlign: 'left' }} onSubmit={handleSubmit}>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
                    {t('cta.form.fields.name.label')}
                    <input
                      type='text'
                      name='name'
                      required
                      placeholder={t('cta.form.fields.name.placeholder')}
                      value={name}
                      onChange={e => setName(e.target.value)}
                      disabled={isSubmitting}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: 6,
                        border: '1px solid #ddd',
                        marginTop: 4,
                        marginBottom: 12,
                        opacity: isSubmitting ? 0.7 : 1
                      }}
                    />
                  </label>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>
                    {t('cta.form.fields.email.label')}
                    <input
                      type='email'
                      name='email'
                      required
                      placeholder={t('cta.form.fields.email.placeholder')}
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      disabled={isSubmitting}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        borderRadius: 6,
                        border: '1px solid #ddd',
                        marginTop: 4,
                        marginBottom: 16,
                        opacity: isSubmitting ? 0.7 : 1
                      }}
                    />
                  </label>
                  {submitError && (
                    <div style={{
                      color: '#dc3545',
                      fontSize: '14px',
                      marginBottom: '16px',
                      padding: '8px',
                      backgroundColor: '#f8d7da',
                      border: '1px solid #f5c6cb',
                      borderRadius: '4px'
                    }}>
                      {submitError}
                    </div>
                  )}
                  <input type='hidden' name='referral' value={referral} />
                  <button
                    type='submit'
                    className='button pink'
                    disabled={isSubmitting}
                    style={{
                      width: '100%',
                      opacity: isSubmitting ? 0.7 : 1,
                      cursor: isSubmitting ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {isSubmitting ? 'Отправка...' : t('cta.form.button')}
                  </button>
                </form>
              </div>
              <div className='col-lg-6'></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { CTA };
